export class BlockDecor {
	constructor(type, game, speedModifier) {
		this.game = game;
		this.type = type;
		this.image = document.getElementById(type);
		this.imageScale = 0.5;
		this.width = this.image.width * this.imageScale;
		this.height = this.image.height * this.imageScale;
		this.xOffset = this.type === 'duck' ? this.width * 3 : this.game.width;
		this.startX = this.game.width + this.xOffset;
		this.x = this.startX;
		this.y = this.setY();
		this.speedModifier = speedModifier ? speedModifier : 1;
		this.speed = this.game.river.speed * this.speedModifier;
		this.hide = false;
		this.maxCount = type === 'duck' ? 2 : 1;
		this.currenCount = 1;
		this.decors = [];
		this.decorOffsetX = this.width + 5;
		this.decorOffsetY = this.height / 2;
		this.setCount();
		this.setDecors();
	}

	setY() {
		return this.game.river.height / 2 + this.game.river.y - this.height / 2;
	}

	updateSpeed() {
		if (this.speedModifier > 1) {
			this.speedModifier = Math.random() * 0.8;
			this.speed = this.game.river.speed * this.speedModifier;
		}
	}

	setCount() {
		this.currenCount = Math.round(Math.random() * this.maxCount);
	}

	setDecorPosition(direction) {
		this.decors.push({
			x: this.x + this.decorOffsetX * direction,
			y: this.y + this.decorOffsetY * Math.random() * direction,
		});
	}

	setDecors() {
		this.decors = [];
		let direction = -1;

		for (let i = 0; i < this.currenCount; i++) {
			if (direction > 0) {
				this.setDecorPosition(direction);
				direction = -1;
			} else {
				this.setDecorPosition(direction);
				direction = 1;
			}
		}
	}

	resetPosition() {
		const delay = Math.random() * 6000 + 10000;
		this.hide = true;
		this.x = this.startX;

		if (this.maxCount > 1) {
			this.setCount();
			this.setDecors();
		}

		this.updateSpeed();

		setTimeout(() => {
			this.hide = false;
		}, delay);
	}

	moveForvard() {
		this.x += this.speed;

		this.decors.forEach((decor) => {
			decor.x += this.speed;
		});

		if (this.x > this.game.width + this.xOffset && !this.isHide) {
			this.resetPosition();
		}
	}

	moveRevers() {
		this.x -= this.speed;

		this.decors.forEach((decor) => {
			decor.x -= this.speed;
		});

		if (this.x < 0 - this.xOffset && !this.isHide) {
			this.resetPosition();
		}
	}

	update() {
		if (!this.hide) {
			this.moveRevers();
		}
	}

	draw() {
		this.game.ctx.drawImage(this.image, this.x, this.y, this.width, this.height);

		this.decors.forEach((decor) => {
			this.game.ctx.drawImage(this.image, decor.x, decor.y, this.width, this.height);
		});
	}

	reset() {
		this.resetPosition();
	}

	resize() {
		this.startX = this.game.width + this.xOffset;
		this.y = this.setY();
		this.setDecors();
	}
}
